import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Action Progress Dialog]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)
export const setShow = createAction(
    `${ SOURCE } SetShow`, props<{ show: boolean; text?: string }>(),
)
export const setText = createAction(
    `${ SOURCE } SetText`, props<{ text: string }>(),
)
export const resetShow = createAction(
    `${ SOURCE } ResetShow`,
)
export const resetText = createAction(
    `${ SOURCE } ResetText`,
)
export const showDialog = createAction(
    `${ SOURCE } ShowDialog`, props<{ show: boolean; text?: string }>(),
)
